<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import toastMixin from '../mixins/toast'
import modalMixin from '../mixins/modal'
import CreateCustomDoc from '../views/create_custom_doc/CreateCustomDoc.vue'
import EditCustomDoc from '../views/edit_custom_doc/EditCustomDoc.vue'
import EditCustomDocLocation from '../views/edit_custom_doc/EditCustomDocLocation.vue'
import EditCustomDocEmployeeSignature from '../views/edit_custom_doc/EditCustomDocEmployeeSignature.vue'
import EditCustomDocEmployerSignature from '../views/edit_custom_doc/EditCustomDocEmployerSignature.vue'
import EditCustomDocLoanoutSignature from '../views/edit_custom_doc/EditCustomDocLoanoutSignature.vue'

export default Vue.extend({
    components: {
        AgGridVue,
        CreateCustomDoc,
        EditCustomDoc,
        EditCustomDocLocation,
        EditCustomDocEmployeeSignature,
        EditCustomDocEmployerSignature,
        EditCustomDocLoanoutSignature,
    },
    mixins: [toastMixin, modalMixin],
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
        selectedProjectName: {
            required: false,
            type: String,
            default: () => {
                return ''
            },
        },
    },
    data() {
        return {
            showCustomField: false,
            selectedCustomDocResource: null,
            locationData: {},
            employeeSignatureData: {},
            employerSignatureData: {},
            loanoutSignatureData: {},
            customDocsColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    width: 100,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.id
                    },
                },
                {
                    field: 'name',
                    headerName: 'Name',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        params.data.set('name', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.name
                    },
                },
                {
                    field: 'description',
                    headerName: 'Description',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        params.data.set('description', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.description
                    },
                },
                {
                    field: 'path',
                    headerName: 'File',
                    width: 100,
                    valueGetter: (params) => {
                        return params.data.attributes.path
                    },
                    onCellDoubleClicked: () => {
                        this.editFile()
                    },
                },
                {
                    field: 'ack_required',
                    headerName: 'Ack Required',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('ack_required') > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            params.data.set('ack_required', event.target.checked ? 1 : 0)
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ack_required
                    },
                },
                {
                    field: 'ack_message',
                    headerName: 'Ack Message',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        params.data.set('ack_message', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ack_message
                    },
                },
                {
                    field: 'selected',
                    headerName: 'Selected',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('selected') > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            params.data.set('selected', event.target.checked ? 1 : 0)
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.selected
                    },
                },
                {
                    field: 'sort_order',
                    headerName: 'Sort order',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        params.data.set('sort_order', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.sort_order
                    },
                },
                {
                    field: 'status',
                    headerName: 'Status',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('status') > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            params.data.set('status', event.target.checked ? 1 : 0)
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.status
                    },
                },
                {
                    field: 'document_type_id',
                    headerName: 'Document Type Id',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        params.data.set('document_type_id', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.document_type_id
                    },
                },
                {
                    field: 'entities',
                    headerName: 'Entities',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        let properties = params.data.get('properties')
                        properties.entities = params.newValue.split(',')
                        params.data.set('properties', JSON.stringify(properties))
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.entities
                        } else return params.data.attributes.properties.entities
                    },
                },
                {
                    field: 'locations',
                    headerName: 'Locations',
                    sortable: true,
                    width: 100,
                    onCellDoubleClicked: () => {
                        this.locationData = this.selectedCustomDocResource
                        this.editLocation()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.locations ? JSON.stringify(properties.locations) : ''
                        } else return params.data.attributes.properties.locations ? JSON.stringify(params.data.attributes.properties.locations) : ''
                    },
                },
                {
                    field: 'departments',
                    headerName: 'Departments',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        let properties = params.data.get('properties')
                        properties.departments = params.newValue
                        params.data.set('properties', JSON.stringify(properties))
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.departments
                        } else return params.data.attributes.properties.departments
                    },
                },
                {
                    field: 'required',
                    headerName: 'Required',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('properties').required > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            let properties = params.data.get('properties')
                            properties.required = event.target.checked ? 1 : 0
                            params.data.set('properties', JSON.stringify(properties))
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.required
                        } else return params.data.attributes.properties.required
                    },
                },
                {
                    field: 'start_doc',
                    headerName: 'Start Doc',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('properties').start_doc > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            let properties = params.data.get('properties')
                            properties.start_doc = event.target.checked ? 1 : 0
                            params.data.set('properties', JSON.stringify(properties))
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.start_doc
                        } else return params.data.attributes.properties.start_doc
                    },
                },
                {
                    field: 'union_doc',
                    headerName: 'Union Doc',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('properties').union_doc > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            let properties = params.data.get('properties')
                            properties.union_doc = event.target.checked ? 1 : 0
                            params.data.set('properties', JSON.stringify(properties))
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.union_doc
                        } else return params.data.attributes.properties.union_doc
                    },
                },
                {
                    field: 'nonunion_doc',
                    headerName: 'Nonunion Doc',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('properties').nonunion_doc > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            let properties = params.data.get('properties')
                            properties.nonunion_doc = event.target.checked ? 1 : 0
                            params.data.set('properties', JSON.stringify(properties))
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.nonunion_doc
                        } else return params.data.attributes.properties.nonunion_doc
                    },
                },
                {
                    field: 'loanout_doc',
                    headerName: 'Loanout Doc',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('properties').loanout_doc > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            let properties = params.data.get('properties')
                            properties.loanout_doc = event.target.checked ? 1 : 0
                            params.data.set('properties', JSON.stringify(properties))
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.loanout_doc
                        } else return params.data.attributes.properties.loanout_doc
                    },
                },
                {
                    field: 'nonloanout_doc',
                    headerName: 'Nonloanout Doc',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('properties').nonloanout_doc > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            let properties = params.data.get('properties')
                            properties.nonloanout_doc = event.target.checked ? 1 : 0
                            params.data.set('properties', JSON.stringify(properties))
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.nonloanout_doc
                        } else return params.data.attributes.properties.nonloanout_doc
                    },
                },
                {
                    field: 'overrides',
                    headerName: 'Overrides',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        let properties = params.data.get('properties')
                        properties.overrides = params.newValue.split(',')
                        params.data.set('properties', JSON.stringify(properties))
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.overrides
                        } else return params.data.attributes.properties.overrides
                    },
                },
                {
                    field: 'time_updated',
                    headerName: 'Time Updated',
                    sortable: true,
                    width: 100,
                    valueGetter: (params) => {
                        return params.data.attributes.time_updated
                    },
                },
                {
                    field: 'time_added',
                    headerName: 'Time Added',
                    sortable: true,
                    width: 100,
                    valueGetter: (params) => {
                        return params.data.attributes.time_added
                    },
                },
                {
                    field: 'employee_signature',
                    headerName: 'Employee signature',
                    sortable: true,
                    width: 100,
                    onCellDoubleClicked: () => {
                        this.employeeSignatureData = this.selectedCustomDocResource
                        this.editEmployeeSignature()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return JSON.stringify(properties.employee_signature)
                        } else return JSON.stringify(params.data.attributes.properties.employee_signature)
                    },
                },
                {
                    field: 'employer_signature',
                    headerName: 'Employer signature',
                    sortable: true,
                    width: 100,
                    onCellDoubleClicked: () => {
                        this.employerSignatureData = this.selectedCustomDocResource
                        this.editEmployerSignature()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return JSON.stringify(properties.employer_signature)
                        } else return JSON.stringify(params.data.attributes.properties.employer_signature)
                    },
                },
                {
                    field: 'loanout_signature',
                    headerName: 'Loanout signature',
                    sortable: true,
                    width: 100,
                    onCellDoubleClicked: () => {
                        this.loanoutSignatureData = this.selectedCustomDocResource
                        this.editLoanoutSignature()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return JSON.stringify(properties.loanout_signature)
                        } else return JSON.stringify(params.data.attributes.properties.loanout_signature)
                    },
                },
                {
                    field: 'employer_allowed_signatures',
                    headerName: 'Employer Allowed Signatures',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        let properties = params.data.get('properties')
                        properties.employer_allowed_signatures = params.newValue.split(',')
                        params.data.set('properties', JSON.stringify(properties))
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        if (typeof params.data.attributes.properties === 'string') {
                            let properties = JSON.parse(params.data.attributes.properties)
                            return properties.employer_allowed_signatures
                        } else return params.data.attributes.properties.employer_allowed_signatures
                    },
                },
            ],
        }
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
        },
        onShowSelectedCustomDocFields() {
            this.$emit('showCustomDocFields')
        },
        selectCustomDoc(params) {
            if (params && params.data) {
                this.showCustomField = true
                this.selectedCustomDocResource = params.data
                this.$emit('select', params.data)
            }
        },
        addCustomDoc() {
            this.showModal('create-custom-doc')
        },
        editFile() {
            this.showModal('edit-custom-doc-file')
        },
        editLocation() {
            this.showModal('edit-custom-doc-location')
        },
        editEmployeeSignature() {
            this.showModal('edit-custom-doc-employee-signature')
        },
        editEmployerSignature() {
            this.showModal('edit-custom-doc-employer-signature')
        },
        editLoanoutSignature() {
            this.showModal('edit-custom-doc-loanout-signature')
        },
    },
})
</script>

<template>
    <div>
        <div class="left">
            <h1>Shows Custom Docs Grid ( {{ this.selectedProjectName }} )</h1>
        </div>
        <div class="right">
            <b-button variant="outline-success" @click="addCustomDoc">Add Custom Doc</b-button>
            <b-button v-if="this.showCustomField" variant="outline-success" @click="onShowSelectedCustomDocFields">Show Selected Fields</b-button>
        </div>
        <div class="clear"></div>
        <ag-grid-vue class="ag-theme-balham default-grid" :column-defs="customDocsColumnDefs" :row-data="rowData" @grid-ready="onGridReady" @row-clicked="selectCustomDoc" />
        <create-custom-doc></create-custom-doc>
        <edit-custom-doc :resource="selectedCustomDocResource"></edit-custom-doc>
        <edit-custom-doc-location :resource="locationData"></edit-custom-doc-location>
        <edit-custom-doc-employee-signature :resource="employeeSignatureData"></edit-custom-doc-employee-signature>
        <edit-custom-doc-employer-signature :resource="employerSignatureData"></edit-custom-doc-employer-signature>
        <edit-custom-doc-loanout-signature :resource="loanoutSignatureData"></edit-custom-doc-loanout-signature>
    </div>
</template>

<style>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
